import Logo from '@assets/qontact-logo-orange.png';
import type { PresenteeismUserRecordSummary } from '@services/QontactPointsService';

interface QontactPointFichajesPdfInput {
    orgName: string;
    qontactPointName: string;
    /** YYYY-MM */
    yearMonth: string;
    records: PresenteeismUserRecordSummary[];
    totalHoursWorked: string;
    totalExtraHoursWorked: string;
}

/**
 * "Exportar datos" of the Fichajes tab: control sheet of the month with every
 * check-in of the qontact point. Same PDF the old "Reporte" tab generated.
 */
export const downloadQontactPointFichajesPdf = async ({
    orgName,
    qontactPointName,
    yearMonth,
    records,
    totalHoursWorked,
    totalExtraHoursWorked,
}: QontactPointFichajesPdfInput) => {
    const [{ default: jsPDF }, { default: autoTable }] = await Promise.all([
        import('jspdf'),
        import('jspdf-autotable'),
    ]);

    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text(`Planilla de control horario ${orgName}`, 15, 20);
    doc.text(`Edificio: ${qontactPointName}`, 15, 30);

    const pageWidth = doc.internal.pageSize.width;
    const logoAspectRatio = 483 / 90;
    const logoWidth = pageWidth * 0.2;
    const logoHeight = logoWidth / logoAspectRatio;
    doc.addImage(Logo, 'PNG', pageWidth - logoWidth - 15, 20, logoWidth, logoHeight);

    const yPosition = 45;
    doc.setFontSize(14);
    if (!records || records.length === 0) {
        doc.text('Sin ingresos para este mes.', 15, yPosition);
    } else {
        autoTable(doc, {
            startY: yPosition,
            head: [['Colaborador', 'Edificio', 'Fecha', 'Ingreso', 'Egreso', 'Horas trabajadas', 'Horas extra']],
            body: records.map((record) => [
                record.userName,
                record.buildingName,
                record.date,
                record.checkInHour,
                record.checkOutHour,
                record.totalHoursWorked,
                record.extraHoursWorked,
            ]),
            theme: 'grid',
            styles: { fontSize: 8 },
            headStyles: { fillColor: [41, 128, 185], textColor: 255 },
        });

        const summaryData = [
            { label: 'Total de horas trabajadas', value: totalHoursWorked },
            { label: 'Total horas extras', value: totalExtraHoursWorked },
        ];
        autoTable(doc, {
            startY: (doc as any).lastAutoTable.finalY + 20,
            body: summaryData.map((item) => [`${item.label}: ${item.value}`]),
            theme: 'grid',
            styles: { fontSize: 8, cellPadding: 2, textColor: [40, 40, 40] },
            columnStyles: {
                0: { cellWidth: 100, fontStyle: 'bold', fillColor: [41, 128, 185], textColor: 255 },
            },
            tableWidth: 'wrap',
            showHead: 'never',
            margin: { left: 15 },
        });

        const finalY = (doc as any).lastAutoTable.finalY + 20;
        doc.setFontSize(10);
        doc.text('Firma del empleador: ________________________', 15, finalY);
        doc.text('Fecha: ________________________', 15, finalY + 15);
    }

    doc.save(`reporte_${qontactPointName}_${yearMonth}.pdf`);
};
